<div #tooglebutton>
    <div class="tooglebuttonlabel" [ngClass]="{'tooglebuttonselected': position}" (click)="change(); positionChanged()"><ng-content></ng-content></div>
</div>
